import AssemblersTable from '@components/users/assemblers/AssemblersTable'
import React from 'react'
import { Panel } from 'rsuite'

export default function AssemblersManagementPage () {
  return (
    <div className="AssemblersManagementPage">
      <AssemblersTable />
    </div>
  )
}
